import { Link } from 'react-router-dom'
import { ArrowRight, type LucideIcon } from 'lucide-react'

// Front-page navigation tile (DESIGN-BRIEF §2). Large = the four FI areas
// (accent icon, prominent); small = the four EN areas (muted icon, visually
// secondary per Kimmo's brief). Hairline border, no shadow; hover tints to
// accent-soft and lifts the border to accent.

interface TileProps {
  to: string
  title: string
  blurb: string
  icon: LucideIcon
  size: 'large' | 'small'
  /** e.g. "(englanniksi)" on EN tiles. */
  langNote?: string
}

export function Tile({ to, title, blurb, icon: Icon, size, langNote }: TileProps) {
  const large = size === 'large'
  return (
    <Link
      to={to}
      className="group flex flex-col rounded border border-hairline bg-paper transition-colors hover:border-accent hover:bg-accent-soft focus-visible:border-accent"
    >
      <div className={large ? 'p-6' : 'p-4'}>
        <Icon
          className={
            large
              ? 'mb-4 h-7 w-7 text-accent'
              : 'mb-3 h-5 w-5 text-muted transition-colors group-hover:text-accent'
          }
          aria-hidden="true"
        />
        {/* h2: the tiles are the front page's primary sections — keeps the heading
            order h1→h2 (no skip) for a11y. Tile is front-page-only. */}
        <h2
          className={
            large
              ? 'flex items-center gap-1.5 text-xl font-semibold tracking-tight text-ink'
              : 'flex items-center gap-1.5 text-base font-medium text-ink'
          }
        >
          {title}
          {large && (
            <ArrowRight
              className="h-4 w-4 -translate-x-1 text-accent opacity-0 transition-all group-hover:translate-x-0 group-hover:opacity-100"
              aria-hidden="true"
            />
          )}
        </h2>
        <p className={large ? 'mt-2 text-muted' : 'mt-1.5 text-sm text-muted'}>
          {blurb}
          {langNote && <span className="ml-1 text-muted">{langNote}</span>}
        </p>
      </div>
    </Link>
  )
}
